import { AppState } from 'pages/app/state';
import { connect, Dispatch } from 'react-redux';
import { DeleteRowsAction, EditRowAction, SelectRowAction } from './actions';
import { layoutSelector } from './selectors';
import { GridProps } from 'semantic-ui-react';

const makeMapStateToProps = () => {
  const mapStateToProps = (state: AppState, props: GridProps): object => {
    return {
      ...layoutSelector(state)[props.gridLayout],
      ...state.userGrid
    };
  };
  return mapStateToProps;
};

function mapDispatchToProps(dispatch: Dispatch<SelectRowAction>): object {
  return {
    onSelectRow: (rowId: string) => dispatch(new SelectRowAction(rowId)),
    onEditRow: (rowId: string) => dispatch(new EditRowAction(rowId)),
    onDeleteRow: (rowId: string) => dispatch(new DeleteRowsAction(rowId)),
  };
}

export default connect(makeMapStateToProps, mapDispatchToProps);


// WEBPACK FOOTER //
// ./src/components/user-grid/container.ts